import { version } from "../../index.js";
import { convexToJson, jsonToConvex } from "../../values/index.js";
import { performAsyncSyscall } from "./syscall.js";

export function setupHttpCalls() {
  return {
    runQuery: async (name: string, ...args: any[]) => {
      const syscallArgs = {
        name,
        args: convexToJson(args),
        version,
      };
      const result = jsonToConvex(
        await performAsyncSyscall("httpEndpoint/runQuery", syscallArgs)
      );
      return result as any;
    },
    runMutation: async (name: string, ...args: any[]) => {
      const syscallArgs = {
        name,
        args: convexToJson(args),
        version,
      };
      const result = jsonToConvex(
        await performAsyncSyscall("httpEndpoint/runMutation", syscallArgs)
      );
      return result as any;
    },
    runAction: async (name: string, ...args: any[]) => {
      const syscallArgs = {
        name,
        args: convexToJson(args),
        version,
      };
      const result = jsonToConvex(
        await performAsyncSyscall("httpEndpoint/runAction", syscallArgs)
      );
      return result as any;
    },
  };
}
